const accessoryCatalog = [
  {
    id: 'bracitos-casement',
    name: 'Bracitos Casement',
    description: 'Brazo de apertura para ventanas casement.',
    price: 30,
    unit: 'unidad',
    appliesTo: ['ventanas'],
  },
  {
    id: 'cajuela-puerta-cilindro',
    name: 'Cajuela puerta con cilindro',
    description: 'Cajuela completa con cilindro instalado.',
    price: 135,
    unit: 'unidad',
    appliesTo: ['puertas'],
  },
  {
    id: 'cajuela-puerta-sin-cilindro',
    name: 'Cajuela puerta sin cilindro',
    description: 'Solo cajuela, sin cilindro.',
    price: 90,
    unit: 'unidad',
    appliesTo: ['puertas'],
  },
  {
    id: 'cambiar-marco-puerta',
    name: 'Cambiar un marco de puerta',
    description: 'Servicio de reemplazo completo del marco.',
    price: 225,
    unit: 'servicio',
    appliesTo: ['puertas'],
  },
  {
    id: 'caulking-blanco',
    name: 'Caulking blanco',
    description: 'Aplicación de sellador blanco.',
    price: 5,
    unit: 'unidad',
    appliesTo: ['ventanas', 'puertas', 'garage'],
  },
  {
    id: 'cerradura-1-hueco',
    name: 'Cerradura 1 hueco handler',
    description: 'Cerradura de un hueco tipo handler.',
    price: 35,
    unit: 'unidad',
    appliesTo: ['puertas'],
  },
  {
    id: 'cerradura-2-huecos',
    name: 'Cerradura 2 huecos pomo',
    description: 'Cerradura de dos huecos con pomo.',
    price: 55,
    unit: 'unidad',
    appliesTo: ['puertas'],
  },
  {
    id: 'cilindro-casement-llave',
    name: 'Cilindro casement con llave',
    description: 'Cilindro para ventana casement con llave.',
    price: 35,
    unit: 'unidad',
    appliesTo: ['ventanas'],
  },
  {
    id: 'cilindro-casement-mariposa',
    name: 'Cilindro casement mariposa',
    description: 'Cilindro con cierre tipo mariposa.',
    price: 50,
    unit: 'unidad',
    appliesTo: ['ventanas'],
  },
  {
    id: 'cilindro-puerta-3-llaves',
    name: 'Cilindro puerta 3 llaves',
    description: 'Cilindro para puerta con 3 llaves.',
    price: 45,
    unit: 'unidad',
    appliesTo: ['puertas'],
  },
  {
    id: 'cilindro-puerta-5-llaves',
    name: 'Cilindro puerta 5 llaves',
    description: 'Cilindro para puerta con 5 llaves.',
    price: 65,
    unit: 'unidad',
    appliesTo: ['puertas'],
  },
  {
    id: 'cilindro-amaestrado',
    name: 'Cilindro amaestrado',
    description: 'Cilindro preparado para amaestramiento.',
    price: 75,
    unit: 'unidad',
    appliesTo: ['puertas'],
  },
  {
    id: 'falleba',
    name: 'Falleba',
    description: 'Mecanismo de cierre multipunto.',
    price: 28.5,
    unit: 'unidad',
    appliesTo: ['puertas', 'ventanas'],
  },
  {
    id: 'goznes-4x4-stainless',
    name: 'Goznes 4x4 stainless steel',
    description: 'Bisagra 4x4 de acero inoxidable.',
    price: 25,
    unit: 'c/u',
    appliesTo: ['puertas'],
  },
  {
    id: 'operador-ventana',
    name: 'Operador ventana',
    description: 'Mecanismo operador de ventana.',
    price: 12.5,
    unit: 'unidad',
    appliesTo: ['ventanas'],
  },
  {
    id: 'pico-cotorra',
    name: 'Pico cotorra',
    description: 'Accesorio de seguridad para puertas.',
    price: 45,
    unit: 'unidad',
    appliesTo: ['puertas'],
  },
  {
    id: 'silicone-blanco',
    name: 'Silicone blanco',
    description: 'Cartucho de silicón blanco.',
    price: 6,
    unit: 'unidad',
    appliesTo: ['ventanas', 'puertas', 'garage'],
  },
  {
    id: 'tornillo-operador-ventana',
    name: 'Tornillo operador ventana',
    description: 'Tornillo específico para operador de ventana.',
    price: 1.25,
    unit: 'c/u',
    appliesTo: ['ventanas'],
  },
  {
    id: 'tornillo-tapcon-blanco',
    name: 'Tornillo tapcon blanco',
    description: 'Tapcon acabado blanco.',
    price: 1.5,
    unit: 'c/u',
    appliesTo: ['ventanas', 'puertas', 'garage'],
  },
  {
    id: 'tornillo-tapcon-stainless',
    name: 'Tornillo tapcon stainless steel',
    description: 'Tapcon de acero inoxidable.',
    price: 1.75,
    unit: 'c/u',
    appliesTo: ['ventanas', 'puertas', 'garage'],
  },
];

export default accessoryCatalog;
